export const TASK_PRIORITY_TABLE_ID = 'F00FFC74-9D5C-4577-BFA5-318F087B68AA'
export const TASK_STATUS_TABLE_ID = '019C55E0-E58B-43B4-B613-7D809915BD78'
export const TASK_TYPE_TABLE_ID = 'BA6F37C8-FFE7-44E1-8F54-6432E1D21B64'
export const CLAIM_STATUS_TABLE_ID = 'BCA0FEE3-09CE-4DCF-9A02-40AA868205C4'
export const LOSS_TYPE_TABLE_ID = 'AA3B0898-AD6D-40AC-B26A-C692B6BF8AB4'
export const MARITAL_STATUS_TABLE_ID = '61F869B6-9B34-4C2A-BDA9-682E977B1A89'
export const INDUSTRIES_TABLE_ID = 'DD4DC65D-E75C-457D-920B-41F0F67CAC4A'
export const OCCUPANCIES_TABLE_ID = 'CC1F06AF-B7BE-413A-AFBB-A9F380FE932E'
export const RELATIONSHIP_TABLE_ID = '64271395-2D25-422E-8C37-E2228B795FFE'
export const STATE_TABLE_ID = '6049E6EB-D7BF-4822-AD27-020CBAF14417'
export const TEMPLATE_STATUS='FFC39848-489B-4235-8851-42AB7EC6AB7C'
export const CAMPAIGN_CATEGORY='9A7408DB-142E-4A07-8305-20164F5E8928'
export const TEMPLATE_TYPE='C00FBB01-8DC5-4A48-A6F2-D75BAF42B870'
export const FIELD_TYPE='4A737673-94E8-4BB2-A376-971AF7A1A8B9'
export const FILTER_CONDITION='50FA4187-B83A-4576-83F9-5897B5FB775D'
export const QUERY_STATUS='F7223F1E-E17D-4877-ADE3-807B16A300BC'
export const DATABASE_SERVER='6F2A9B4C-D371-4E8A-B50C-7D3F1E96A024'
export const CAMPAIGN_STATUS='D9B3B0C9-02F4-4933-9117-052F43A2FF64'
export const CAMPAIGN_FILTER_CONDITIONS ='50FA4187-B83A-4576-83F9-5897B5FB775D'
export const REQUEST_CAMPAIGN_FROM_EMAIL_ADDRESS='112FCF0D-5F8B-4BB1-BD9C-DE4E85DE08A0'
export const RUN_FREQUENCY_TYPE='38C0D8E2-C5B3-4BFD-8707-68B460D163B7'
export const AGENCY_TABLE_ID='7A16F51A-5279-4B77-87A2-60B0B1743D41'
export const ROLE_APP_ID ='549CD2E9-2A3E-4E18-B23E-4AADA2A5A79C'
export const EMPLOYEE_STATUS ='749B4E40-18E0-4915-A70D-C068EB36689B'
export const EMPLOYEE_FULLTIMEIND ='8070FFAB-2A49-435E-9CDD-17FB6A7BC6EF'
export const COUNTRY_TABLE_ID = 'D41C76DF-6E41-4D74-B609-97DDB31C3D2B'
export const US_STATE_TABLE_ID = '68A16C92-4427-42F6-A8B0-06F18C60D38A'
export const CANADA_STATE_TABLE_ID = '930B8763-EB01-4173-BA6F-6BFD646BFDED '
export const TRANSACTION_TYPE_TABLE_ID= "63032C80-D112-4910-B416-DD343905EF1F"
export const INDIVIDUALIZED_TABLE_ID = '3E5A62EE-4E82-4949-B1F2-86781E246C81'
export const GENDER_STATUS_TABLE_ID = 'D2BD4880-A9A3-49E6-BE46-B861E26991BA'
export const REDIRECT_REASON_TABLE_ID='36F353C9-6940-41F7-9489-01BAB062EF8F'
export const SOURCE_TYPE_TABLE_ID='94B13B32-9F25-4B82-986A-AF769F90D188'
export const POLICY_TERM_STATUS_TABLE_ID = '55DD6889-6375-4EE0-86EC-A95DBA2DC416'
export const POLICY_PAYMENT_PLAN_TABLE_ID = 'EAD57F1E-CD99-408C-9864-2D59FFB0A81E'
export const POLICY_BUSINESS_TYPE_TABLE_ID='B5B6BD3B-745E-42EB-AE95-F94A0C4CB0FA'
export const POLICY_TYPE_TABLE_ID='674D4273-F46D-4F2B-8055-C3238D5EB543'
export const DEDUCTIBLE_TYPE_TABLE_ID='816855BE-674D-47B8-AF59-F02CA25DAAF7'
export const HOWBILLED_TABLE_ID='E644C132-5119-42DA-9A3A-56A3CB1FC1BE'
export const ATTACH_TYPE_TABLE_ID = 'CB0E0ADF-3B2E-4E77-BDEA-9DFC7CF5F0C3'
export const LINE_OF_BUSINESS='14624C58-BF80-460B-A782-C0E3E26C5380'
export const TRANSACTION_TYPE='63032C80-D112-4910-B416-DD343905EF1F'
export const OCCUPANCY_TYPE='BAA65293-26D6-4282-A136-DEFDE6DD2469'
export const RESIDENCE_TYPE='6B271A80-0B66-4B05-8103-F5E5EC21348B'
export const CONSTRUCTION_TYPE='5BF59828-499E-41F2-8FFB-1A9D5D68FFCD'
export const ROOF_MATERIAL_TYPE='CA5EA848-D15C-4215-9710-A77F78818789'
export const HEAT_TYPE='A3D559D7-8708-497A-95E4-8DD9AB5FCD6A'
export const SPRINKLER_TYPE='51B92772-C2EB-4FF4-9515-A4064E173C36'
export const DWELLING_CONDITION_TYPE = 'B7874424-7D30-4EFC-98EB-16A652D32133'
export const STORM_SHUTTER_TYPE = '8032530E-F3B1-4D35-8DCE-3B19D4013103'
export const DWELLING_LOC_TYPE='7FEACF49-C185-4EA6-879C-E4A901264124'
export const SECONDARY_HEAT_TYPE='A3D559D7-8708-497A-95E4-8DD9AB5FCD6A'
export const FOUNDATION_TYPE='09DC1EFD-6E6D-42C5-AD66-72354A3814C3'
export const CANCELLATION_REASON='93F29375-7523-4817-935F-4A6822436C9F'
export const LOB_APPLICATION ='8BC9A30A-F5BF-438E-A410-6674550CF4D8'
export const COMPANY_TYPE = 'C2662188-D14E-4508-AE85-45059A4A5E5F'
export const COMPANY_STATUS = '7DE87CF2-3438-494D-8B8D-D52632BB4A2A'
export const FORM_TYPE = 'C517386E-CC51-4876-A4F1-362AB615F9B3'
export const Basement_Type='55CF6FBD-6109-4EFF-BC23-442F997DB931'
export const NUMBER_OF_FLOORS_TYPE='E23E8F95-B06E-48CA-B377-A904C8343669'
export const CONTENT_LOCATION_TYPE='3305F345-E054-4623-80DE-3617FA1224FC'
export const RATING_TYPE='415B562D-DD74-4C8B-8D99-30A41B76E085'
export const NEAREST_SHORE_TYPE='B10089B9-89A2-4B57-B529-3581FA4D6D19'
export const ELEVATED_FOUNDATION_TYPE='7437DD1A-9A55-4012-BF35-F9940ED2B261'
export const ELEVATED_MATERIAL_TYPE='815ED47D-9089-48FF-80F4-0CB7A2847309'
export const ENCLOSED_FOR_OTHER_PURPOSE_TYPE='AC894E24-1ADA-4E14-8864-05BB49F27E31'
export const FLOOD_OCCUPANCY='6630314F-A2A4-4F17-A77E-AFE5AF02B78F'
export const PROTECTION_DEVICE_TYPE='9E906DE8-C152-407E-BDF0-D44B58E9748A'
export const INTEREST_TYPE_TABLE_ID='f2242bba-8f05-47dd-83dc-e15f48ad587b'
export const ADDITIONAL_INTERESTED_PARTY_TABLE_ID='68710BEDA40A42EA85DA3AB877BB4B2F'
export const EMPLOYEE_DEPARTMENT='A1D4E7B2-3F58-4C91-B6A0-9E2C5D8F1A73'
export const MARKET_TYPE_TABLE_ID='F96C92EA-DDE3-4100-BBC1-BCC4776C042A'
export const BUSINESS_TYPE_TABLE_ID='AAE3FAB5-1E27-43CD-8E93-50F4B8839E87'
export const PLAN_TYPE_TABLE_ID='AC83EA6F-3A4E-48E8-AB6E-6E9FD01D9E9C'
export const GROUP_TYPE_TABLE_ID='0C5BA138-C700-4B7A-BA6D-77FE0CBF44DE'
